var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.875C10.0261 11.875 10.25 11.6511 10.25 11.375V6.375C10.25 6.0989 10.0261 5.875 9.75 5.875C9.4739 5.875 9.25 6.0989 9.25 6.375V11.375C9.25 11.6511 9.4739 11.875 9.75 11.875Z",
    fill: "#DE3745"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 11.875C6.5261 11.875 6.75 11.6511 6.75 11.375V6.375C6.75 6.0989 6.5261 5.875 6.25 5.875C5.9739 5.875 5.75 6.0989 5.75 6.375V11.375C5.75 11.6511 5.9739 11.875 6.25 11.875Z",
    fill: "#DE3745"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.125C10.2761 2.125 10.5 1.9011 10.5 1.625C10.5 1.3489 10.2761 1.125 10 1.125H6C5.7239 1.125 5.5 1.3489 5.5 1.625C5.5 1.9011 5.7239 2.125 6 2.125H10Z",
    fill: "#DE3745"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.625C2.2239 2.625 2 2.8489 2 3.125C2 3.4011 2.2239 3.625 2.5 3.625H3V12.825C3 13.955 3.92 14.875 5.05 14.875H10.95C12.08 14.875 13 13.955 13 12.825V3.625H13.5C13.7761 3.625 14 3.4011 14 3.125C14 2.8489 13.7761 2.625 13.5 2.625H12.5H3.5H2.5ZM12 3.625V12.825C12 13.405 11.53 13.875 10.95 13.875H5.05C4.47 13.875 4 13.405 4 12.825V3.625H12Z",
    fill: "#DE3745"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/removeIcon.88830c34963dd5de76b2a69a33e4e320.svg";
export { ForwardRef as ReactComponent };